import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "text", "button"]

  connect() {
    this.slideCount = this.panelTargets.length
    this.#activatePanel(0)
  }

  switch({ currentTarget } = event) {
    this.#activatePanel(this.buttonTargets.indexOf(currentTarget) || 0)
  }

  #activatePanel(index) {
    let i = 0, isActive
    while (i < this.slideCount) {
      isActive = i === index
      this.panelTargets[i].classList.toggle("is-active", isActive)
      this.textTargets[i].classList.toggle("is-active", isActive)
      this.buttonTargets[i].toggleAttribute("active", isActive)
      i++
    }
  }
}
